import { EXERCISE_PART_TYPES as SECTION_TYPES } from "@/constants/exerciseConstants";
import { Box, Typography } from "@mui/material";
import {
  VocabularySection,
  DescriptionSection,
  ExerciseSection,
} from "./sections";


const SectionMainContent = ({
  selectedSection,
  selectedDay,
  progress,
  exerciseId,
  onSessionStart,
  onSessionEnd,
  isSidebarCollapsed,
  onToggleSidebar,
}) => {
  if (!selectedDay) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="h6" color="text.secondary">
          Please select a day and section to view content
        </Typography>
      </Box>
    );
  }

  const sectionConfig = SECTION_TYPES[selectedSection];

  if (!sectionConfig) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="h6" color="text.secondary">
          Invalid section selected
        </Typography>
      </Box>
    );
  }

  // Render appropriate section component based on selected section
  switch (selectedSection) {
    case "vocabulary":
      return (
        <VocabularySection
          selectedDay={selectedDay}
          progress={progress}
          exerciseId={exerciseId}
        />
      );

    case "description":
      return (
        <DescriptionSection
          selectedDay={selectedDay}
          progress={progress}
          sectionConfig={sectionConfig}
        />
      );

    case "lcExercise":
    case "rcExercise":
    case "attendanceTest":
      return (
        <ExerciseSection
          selectedDay={selectedDay}
          selectedSection={selectedSection}
          progress={progress}
          sectionConfig={sectionConfig}
          exerciseId={exerciseId}
          onSessionStart={onSessionStart}
          onSessionEnd={onSessionEnd}
          isSidebarCollapsed={isSidebarCollapsed}
          onToggleSidebar={onToggleSidebar}
        />
      );

    default:
      return (
        <Box textAlign="center" py={4}>
          <Typography variant="h6" color="text.secondary">
            Content for this section is not available yet
          </Typography>
        </Box>
      );
  }
};

export default SectionMainContent;
